import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppNavbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Verify from "./pages/Verify";
import Registry from "./pages/Registry";
import TestMarketplace from "./pages/TestMarketplace";
import Buy from "./pages/Buy";
import ChangePassword from "./pages/ChangePassword";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Profile from "./pages/Profile";
import TermsOfUse from "./pages/TermsOfUse";
import MaintenanceCheck from "./components/MaintenanceCheck";
import PublicBrowse from "./pages/PublicBrowse";

function App() {
  return (
    <Router>
      <MaintenanceCheck>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <AppNavbar />
          <div style={{ flex: 1 }}>
            <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/browse" element={<PublicBrowse />} />
        <Route path="/test" element={<TestMarketplace />} />
        <Route path="/verify/:token" element={<Verify />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
        />
        <Route path="/registry" element={
          <ProtectedRoute>
            <Registry />
          </ProtectedRoute>
        }
        />
        <Route path="/buy" element={
          <ProtectedRoute>
            <Buy />
          </ProtectedRoute>
        }
        />
        <Route path="/change-password" element={
          <ProtectedRoute>
            <ChangePassword />
          </ProtectedRoute>
        }
        />
        <Route path="/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
        />
        {/* <Route path="/sell" element={
          <ProtectedRoute>
            <Sell />
          </ProtectedRoute>
        }
        /> */}
        <Route path="*" element={<Landing />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </MaintenanceCheck>
    </Router>
  );
}

export default App;
